const model = {
    product: null,
    stock: [],
    loading: false,
    error: null,
};

export default model;